import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { records as userRecords } from '@saucelabs/sl-module-user';
import { recordTrack } from '@saucelabs/sl-util-segmentio';

import RdcErrorPage from '../sessionReal/RdcErrorPage';
import MobileAppInfo from '../../components/MobileAppInfo';
import * as actions from '../../actions';
import Styles from './AppSelectionContainer.styles';
import AppsManagementContainer from './AppsManagementContainer';

class AppSelectionContainer extends Component {
  componentDidMount() {
    const { getRdcUserData, user } = this.props;

    const userData = {
      ancestor: user.ancestor,
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
    };

    getRdcUserData(userData);
  }

  handleChangeClick = () => {
    const { onAppSelect } = this.props;
    recordTrack('App selection opened');
    return onAppSelect(null);
  }

  handleAppClick = (app) => {
    const { onAppSelect } = this.props;
    recordTrack('App selected', { app });
    onAppSelect(app.toObject());
  }

  render() {
    const { meta, mobileAppConfiguration } = this.props;

    if (!mobileAppConfiguration) {
      return (
        <RdcErrorPage>
          <AppsManagementContainer
            {...{ meta }}
            handleAppClick={this.handleAppClick}
          />
        </RdcErrorPage>
      );
    }

    return (
      <div className={Styles.default}>
        <MobileAppInfo
          name={mobileAppConfiguration.displayName}
          onClick={this.handleChangeClick}
          platform={mobileAppConfiguration.platform}
        />
      </div>
    );
  }
}

// TODO: Refactor to make use of selectors
AppSelectionContainer.propTypes = {
  apps: PropTypes.object.isRequired,
  getRdcUserData: PropTypes.func.isRequired,
  meta: PropTypes.object.isRequired,
  mobileAppConfiguration: PropTypes.any,
  onAppSelect: PropTypes.func.isRequired,
  user: ImmutablePropTypes.recordOf(userRecords.UserRecordClass).isRequired,
};

AppSelectionContainer.defaultProps = {
  mobileAppConfiguration: null,
};

const mapStateToProps = (state) => {
  const formValues = formValueSelector('manualAppTesting')(state, 'mobileAppConfiguration', 'platformType');

  return ({
    apps: state.apps.manual.apps,
    mobileAppConfiguration: formValues.mobileAppConfiguration,
    platformType: formValues.platformType,
    user: state.user,
  });
};

const mapDispatchToProps = {
  getRdcUserData: actions.getRdcUserData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppSelectionContainer);
export { AppSelectionContainer, mapStateToProps, mapDispatchToProps };
